import fieldsValidationRules from '../../utils/fieldsValidationRules';
import gridViewFieldsUtils from '../../utils/gridViewFieldsUtils';
import { formFieldRule } from '../../enums/formFieldRuleEnum';
import { FieldDataTypes } from '../../enums/fieldDataTypes';
import projectSettingsMixin from '../../mixins/projectSettingsMixin';
export default {
	mixins: [projectSettingsMixin],
	data() {
		return {
			defaultRules: [],
			dynamicRules: [],
		};
	},
	props: {
		formField: Object,
		record: Object,
		uniqueFields: Array,
	},
	computed: {
		validationRules() {
			let validateUniqueFields = true;
			if (this.formField && this.uniqueFields) {
				validateUniqueFields =
					!this.uniqueFields.includes(
						this.formField.GridViewFields[0].DataField.Id
					) || 'This value must be unique';
			}

			return [
				...this.defaultRules,
				...this.dynamicRules,
				validateUniqueFields,
			];
		},
	},
	mounted() {
		//this.defaultRules.push(fieldsValidationRules.ruleRequired);
		this.updateValidationRules();
	},
	methods: {
		updateValidationRules() {
			let rules = [];
			if (this.formField.FormFieldRules) {
				this.formField.FormFieldRules.forEach((r) => {
					switch (r.Operator) {
						case formFieldRule.Alpha:
							rules.push((v) =>
								fieldsValidationRules.validationAlpha(v)
							);
							break;
						case formFieldRule.Accepted:
							rules.push((v) =>
								fieldsValidationRules.validationAccepted(v)
							);
							break;
						case formFieldRule.AfterD:
							rules.push((v) => this.afterD(v, r.Value));
							break;
						case formFieldRule.AlphaDash:
							rules.push((v) =>
								fieldsValidationRules.validationAlphaDash(v)
							);
							break;
						case formFieldRule.AlphaNum:
							rules.push((v) =>
								fieldsValidationRules.validationAlphaNum(v)
							);
							break;
						case formFieldRule.BeforeD:
							rules.push((v) => this.beforeD(v, r.Value));
							break;
						case formFieldRule.BetweenXY:
							rules.push((v) => this.betweenXY(v, r));
							break;
						case formFieldRule.ConfirmedFAndSameF:
							rules.push((v) => this.confirmedFAndSameF(v, r));
							break;
						case formFieldRule.DifferentF:
							rules.push((v) => this.differentF(v, r));
							break;
						case formFieldRule.Date:
							rules.push((v) =>
								fieldsValidationRules.validationDate(
									v,
									this.getDateTimeFormatProjectSetting()
								)
							);
							break;
						case formFieldRule.In:
							rules.push((v) => this.in(v, r));
							break;
						case formFieldRule.IntegerAndNumeric:
							rules.push((v) =>
								fieldsValidationRules.validationIntegerAndNumeric(
									v
								)
							);
							break;
						case formFieldRule.Ip:
							rules.push((v) =>
								fieldsValidationRules.validationIp(v)
							);
							break;
						case formFieldRule.MaxX:
							rules.push((v) => this.maxX(v, r));
							break;
						case formFieldRule.MinX:
							rules.push((v) => this.minX(v, r));
							break;
						case formFieldRule.NotIn:
							rules.push((v) => this.notIn(v, r));
							break;
						case formFieldRule.Regex:
							rules.push((v) =>
								fieldsValidationRules.validationRegex(
									v,
									r.Value
								)
							);
							break;
						case formFieldRule.RequiredIf:
							rules.push((v) => this.requiredIf(v, r));
							break;
						case formFieldRule.RequiredWith:
							rules.push((v) => this.requiredWith(v, r));
							break;
						case formFieldRule.RequiredWithout:
							rules.push((v) => this.requiredWithout(v, r));
							break;
						case formFieldRule.RequiredWithoutAll:
							rules.push((v) =>
								fieldsValidationRules.validationRequiredWithoutAll(
									v
								)
							);
							break;
						case formFieldRule.Size:
							rules.push((v) =>
								fieldsValidationRules.validationSize(v, r.Value)
							);
							break;
						case formFieldRule.Url:
							rules.push((v) =>
								fieldsValidationRules.validationUrl(v)
							);
							break;
						case formFieldRule.MaxOne:
							rules.push((v) =>
								fieldsValidationRules.validationMaxOne(v)
							);
							break;
						case formFieldRule.MaxOneIf:
							rules.push((v) =>
								fieldsValidationRules.validationMaxOneIf(v)
							);
							break;
						case formFieldRule.MaxOneUnless:
							rules.push((v) =>
								fieldsValidationRules.validationMaxOneUnless(v)
							);
							break;
					}
				});
			}
			this.dynamicRules = rules;
		},
		afterD(v, r) {
			if (
				fieldsValidationRules.validationDate(
					v,
					this.getDateTimeFormatProjectSetting()
				) === true
			)
				return fieldsValidationRules.validationAfterD(v, r);
			return fieldsValidationRules.validationDate(
				v,
				this.getDateTimeFormatProjectSetting()
			);
		},
		beforeD(v, r) {
			if (
				fieldsValidationRules.validationDate(
					v,
					this.getDateTimeFormatProjectSetting()
				) === true
			)
				return fieldsValidationRules.validationBeforeD(v, r);
			return fieldsValidationRules.validationDate(
				v,
				this.getDateTimeFormatProjectSetting()
			);
		},
		betweenXY(v, r) {
			let value1 = parseInt(r.Value.split(',')[0]);
			let value2 = parseInt(r.Value.split(',')[1]);
			let length = 0;
			switch (this.formField.GridViewFields[0].DataField.DataType) {
				case FieldDataTypes.AMOUNT:
				case FieldDataTypes.NUMBER:
					if (isNaN(parseInt(v))) return true;
					if (
						!fieldsValidationRules.validationBetweenXY(
							v,
							value1,
							value2
						)
					)
						return (
							false ||
							'Value must be between ' + value1 + ' and ' + value2
						);
					return true;
				case FieldDataTypes.TEXT:
				case FieldDataTypes.LONG_TEXT:
					if (v != null) length = v.length;
					if (
						!fieldsValidationRules.validationBetweenXY(
							length,
							value1,
							value2
						)
					)
						return (
							false ||
							'Length must be between ' +
								value1 +
								' and ' +
								value2
						);
					return true;
			}
		},
		confirmedFAndSameF(v, r) {
			let result = true;
			let value =
				this.record[
					gridViewFieldsUtils.getFieldName(
						r.FormFields[0].GridViewFields[0]
					)
				];
			if (value === undefined) if (v === null || v === '') return result;
			r.FormFields.forEach((f) => {
				let key = gridViewFieldsUtils.getFieldName(f.GridViewFields[0]);
				if (
					!fieldsValidationRules.validationConfirmedFAndSameF(
						v,
						this.record[key]
					)
				) {
					result = false;
				}
			});
			return (
				result ||
				'Value must be the same as ' +
					r.FormFields[0].GridViewFields[0].Label
			);
		},
		differentF(v, r) {
			let result = true;
			let fields = [];
			r.FormFields.forEach((f) => {
				let key = gridViewFieldsUtils.getFieldName(f.GridViewFields[0]);
				fields.push(f.GridViewFields[0].Label);
				if (this.record[key] === undefined)
					if (!fieldsValidationRules.validationDifferentF(v, null)) {
						result = false;
					}
				if (
					!fieldsValidationRules.validationDifferentF(
						v,
						this.record[key]
					)
				) {
					result = false;
				}
			});
			return result || 'Value must be diffrent than ' + fields;
		},
		in(v, r) {
			let values = r.Value.split(',');
			return fieldsValidationRules.validationIn(v, values);
		},
		maxX(v, r) {
			let length = 0;
			switch (this.formField.GridViewFields[0].DataField.DataType) {
				case FieldDataTypes.AMOUNT:
					if (isNaN(parseInt(v))) return true;
					if (
						!fieldsValidationRules.validationMaxX(
							parseInt(v),
							parseInt(r.Value)
						)
					)
						return (
							false ||
							'Value must be lower or equal than ' + r.Value
						);
					return true;
				case FieldDataTypes.NUMBER:
					if (isNaN(parseInt(v))) return true;
					if (
						!fieldsValidationRules.validationMaxX(
							parseInt(v),
							parseInt(r.Value)
						)
					)
						return (
							false ||
							'Value must be lower or equal than ' + r.Value
						);
					return true;
				case FieldDataTypes.TEXT:
					if (v != null) length = v.length;
					if (!fieldsValidationRules.validationMaxX(length, r.Value))
						return (
							false ||
							'The length must be lower or equal than ' + r.Value
						);
					return true;
				case FieldDataTypes.LONG_TEXT:
					if (v != null) length = v.length;
					if (!fieldsValidationRules.validationMaxX(length, r.Value))
						return (
							false ||
							'The length must be lower or equal than ' + r.Value
						);
					return true;
			}
		},
		minX(v, r) {
			let length = 0;
			switch (this.formField.GridViewFields[0].DataField.DataType) {
				case FieldDataTypes.AMOUNT:
					if (isNaN(parseInt(v))) return true;
					if (
						!fieldsValidationRules.validationMinX(
							parseInt(v),
							parseInt(r.Value)
						)
					)
						return (
							false ||
							'Value must be higher or equal than ' + r.Value
						);
					return true;
				case FieldDataTypes.NUMBER:
					if (isNaN(parseInt(v))) return true;
					if (
						!fieldsValidationRules.validationMinX(
							parseInt(v),
							parseInt(r.Value)
						)
					)
						return (
							false ||
							'Value must be higher or equal than ' + r.Value
						);
					return true;
				case FieldDataTypes.TEXT:
					if (v != null) length = v.length;
					if (!fieldsValidationRules.validationMinX(length, r.Value))
						return (
							false ||
							'The length must be higher or equal than ' + r.Value
						);
					return true;
				case FieldDataTypes.LONG_TEXT:
					if (v != null) length = v.length;
					if (!fieldsValidationRules.validationMinX(length, r.Value))
						return (
							false ||
							'The length must be higher or equal than ' + r.Value
						);
					return true;
			}
		},
		notIn(v, r) {
			let values = r.Value.split(',');
			return fieldsValidationRules.validationNotIn(v, values);
		},
		requiredIf(v, r) {
			let result = false;
			r.FormFields.forEach((f) => {
				let key = gridViewFieldsUtils.getFieldName(f.GridViewFields[0]);
				if (r.Value == this.record[key])
					if (v == null || v == '') result = true;
			});
			if (result) return fieldsValidationRules.validationRequiredIf(v);
			return true;
		},
		requiredWith(v, r) {
			let result = true;
			let fields = [];
			r.FormFields.forEach((f) => {
				fields.push(f.Label);
				let key = gridViewFieldsUtils.getFieldName(f.GridViewFields[0]);
				if (Object.prototype.hasOwnProperty.call(this.record, key)) {
					if (this.record[key] == null || this.record[key] == '')
						result = false;
				} else {
					result = false;
				}
			});
			if (result)
				return fieldsValidationRules.validationRequiredWith(v, fields);
			return true;
		},
		requiredWithout(v, r) {
			let result = false;
			let fields = [];
			r.FormFields.forEach((f) => {
				fields.push(f.Label);
				let key = gridViewFieldsUtils.getFieldName(f.GridViewFields[0]);
				if (Object.prototype.hasOwnProperty.call(this.record, key)) {
					if (this.record[key] == null || this.record[key] == '')
						result = true;
				} else {
					result = true;
				}
			});
			if (result)
				return fieldsValidationRules.validationRequiredWithout(
					v,
					fields
				);
			return true;
		},
	},
};
